import { FacetFilter, isRangeFilter } from '@app/core/search/filtering/types';
import { FacetFilterMapping } from '@app/core/search/mapping/types';

export abstract class AbstractMapper {
  /**
   * A map of all route params and their respective facets.
   *
   * Example: `"brand" => { attributeName: "brand.facet", type: FilterType.RefinementList }`
   */
  protected facets: Map<string, FacetFilter> = new Map();

  setFacets(facets: FacetFilterMapping): void {
    this.facets.clear();

    Object.keys(facets).forEach(routeParam => {
      this.setFacet(routeParam, facets[routeParam]);
    });
  }

  setFacet(routeParam: string, facet: FacetFilter): AbstractMapper {
    this.facets.set(routeParam, facet);

    if (isRangeFilter(facet.type)) {
      this.facets.set(`${routeParam}Min`, facet);
      this.facets.set(`${routeParam}Max`, facet);
    }

    return this;
  }

  getFacetFilter(filter: string) {
    return this.facets.get(filter);
  }
}
